export enum RouteEnum {
  MONITORING = 'monitoring',
  VIRTUAL_LOBBY = 'virtualLobby',
  ACCESS_MONITORING = 'accessMonitoring',
  DEVICE_SEARCH = 'deviceSearch',
  ACCESS_CALL_LOG = 'accessCallLog'
}
